const languages = {
  selectLanguage: "Select a language"
};

export default languages;
